import React from 'react';



const GetToKnowWorkDeskVA = () => {
    return (
        <section className="get-to-know-section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="office-image">
                            <img 
                                src="/assets/images/about/about-us.jpg" 
                                alt="Work Desk VA Office" 
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="content-wrapper">
                            <div className="section-title">
                                <h2>Get to Know <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span></h2>
                                <p className=" text-start">
                                    <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span> is a leading remote staffing company dedicated to connecting businesses with top-tier virtual professionals. Our mission is to empower companies to scale efficiently by providing reliable, skilled, and flexible remote talent across a wide range of industries. Discover how our commitment to quality and client success has made us a trusted partner for organizations worldwide.
                                </p>
                                <div className="mt-4">
                                    <a href="/about" className="btn btn-primary">
                                        <span className="btn_label" data-text="Learn More">Learn More</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GetToKnowWorkDeskVA;